export default "__VITE_ASSET__CrDjRFIR__"